/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper, Grid, Box,
} from '@material-ui/core';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  body: {
    width: '100%',
    height: '100%',
    paddingBottom: '1em',
  },
  buttons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    top: '4.5%',
  },
  buttonbg: (props) => ({
    border: 'none',
    borderRadius: 10,
    backgroundColor: props.darkMode ? '#125076' : theme.palette.primary.main,
    borderColor: '#A7A6A6',
    color: '#eeeeee',
    padding: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: '#ffffff !important',
    },
  }),
  button: {
    border: 'none',
    borderRadius: 20,
    backgroundColor: 'inherit',
    color: '#eeeeee',
    fontSize: '120%',
    padding: '0.25em 0',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    '&:hover': {
      color: '#125076',
      backgroundColor: '#ffffff !important',
    },
  },
  selected: {
    color: '#ffffff',
    backgroundColor: '#06b1e4 !important',
  },
}));

const AlphabetMenu = ({ letter, setLetter, darkMode }) => {
  const classes = useStyles({ darkMode });

  const CreateAlphabetButton = () => {
    const selectors = [];

    for (let i = 65; i <= 90; i += 1) {
      const char = String.fromCharCode(i);
      const isSelected = char === letter.toUpperCase();
      selectors.push(
        <Paper
          className={`${classes.buttonbg} ${isSelected ? classes.selected : ''}`}
          elevation={1}
          key={i}
        >
          <button
            className={`${classes.button} ${isSelected ? classes.selected : ''}`}
            value={char}
            onClick={() => setLetter(char)}
            aria-label={`Select words starting with ${char}`}
          >
            {char}
          </button>
        </Paper>,
      );
    }

    return selectors;
  };

  return (
    <Grid container className={classes.body}>
      <Box display="flex" className={classes.buttons} role="group" aria-label="Alphabet filter">
        <CreateAlphabetButton />
      </Box>
    </Grid>
  );
};

AlphabetMenu.propTypes = {
  letter: PropTypes.string.isRequired,
  setLetter: PropTypes.func.isRequired,
  darkMode: PropTypes.bool.isRequired, // state.ui.darkMode
};

// mapState pour connect()
const mapState = (state) => ({
  darkMode: state.ui.darkMode,
});

export default connect(mapState)(AlphabetMenu);
